import React, { useState } from 'react'
import './App.css'

function App() {
  const [ag, setag] = useState(0)
  const [nob, setnob] = useState(0)
  const [noo, setnoo] = useState(0)
  fetch(`https://api-als2.nutramax.com/items/initiative410`, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  })
    .then((res) => res.json())
    .then((result) => {
      setag(result.data.totalcontributions)
      setnob(result.data.LocalBusinesses)
      setnoo(result.data.CommunityOrganization)
    })

  const box2style = {
    opacity: '1',
    transformStyle: 'preserve-3d',
  }

  return (
    <div className="App">
      <div className="full-width-horiz-container counter">
        <div className="text-container mobile-removepadding _410">
          <div className="largercounter">
            <p className="featurecount featurecount-inline">Over</p>
            <div className="numericcount inline color1">
              <span className="superscript">$</span>
              <span
                data-counterup-time="2000"
                data-counterup-delay="30"
                className="counterup"
              >
                {ag}
              </span>
            </div>
            <p className="featurecount featurecount-inline">
              Given to local businesses &amp; community organizations
            </p>
          </div>
        </div>
      </div>
      <div className="full-width-horiz-container counter2">
        <div className="text-container mobile-removepadding _410">
          <div className="textcounter _410">
            <div className="numericcount inline">
              <span className="counterup">{nob}</span>
              <span>+</span>
            </div>
            <p className="featurecount featurecount-inline">Local Businesses</p>
          </div>
          <div className="textcounter _410" style={box2style}>
            <div className="numericcount inline">
              <span className="counterup">{noo}</span>
              <span>+</span>
            </div>
            <p className="featurecount featurecount-inline">
              Community Organizations
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default App
